// 合作推广公司列表
// ref: (产品需求) https://confluence.zhihuiya.com/pages/viewpage.action?pageId=92597811
// ref: (后端相关) https://confluence.zhihuiya.com/pages/viewpage.action?pageId=113853813
/**
 * 付费类型
 */
export var E_CooperativeCompanyPayType;
(function (E_CooperativeCompanyPayType) {
    /**
     * 合作推广
     */
    E_CooperativeCompanyPayType["COOPERATIVE"] = "COOPERATIVE";
    /**
     * 内部测试
     */
    E_CooperativeCompanyPayType["INTERNAL"] = "INTERNAL";
})(E_CooperativeCompanyPayType || (E_CooperativeCompanyPayType = {}));
/**
 * 公司状态
 */
export var E_CooperativeCompanyStatus;
(function (E_CooperativeCompanyStatus) {
    /**
     * 激活
     */
    E_CooperativeCompanyStatus["Active"] = "Active";
    /**
     * 禁用
     */
    E_CooperativeCompanyStatus["Disable"] = "Disable";
})(E_CooperativeCompanyStatus || (E_CooperativeCompanyStatus = {}));
export var E_CompanyRenderTag;
(function (E_CompanyRenderTag) {
    E_CompanyRenderTag["company_target"] = "company_target";
    E_CompanyRenderTag["identity_company"] = "identity_company";
    E_CompanyRenderTag["legitimate_1"] = "legitimate_1";
    E_CompanyRenderTag["legitimate_0"] = "legitimate_0";
})(E_CompanyRenderTag || (E_CompanyRenderTag = {}));
